import {TicketDBType} from "data/types";
import React, {FC} from "react";
import NcModal from "shared/NcModal/NcModal";

const RaffleTickets: FC<{tickets: TicketDBType[]; luckyNumbers: number[]}> = ({
  tickets,
  luckyNumbers,
}) => {
  return (
    <ul className="grid grid-cols-2 md:grid-cols-6 sm:grid-cols-4 lg:grid-cols-10 gap-6">
      {tickets
        .slice()
        .sort(
          (a, b) =>
            Number(a.tickets.numberRaffle) - Number(b.tickets.numberRaffle)
        )
        .map((ticket: TicketDBType) => {
          const isLucky = luckyNumbers.includes(
            Number(ticket.tickets.numberRaffle)
          );
          return (
            <NcModal
              key={ticket.tickets._id}
              modalTitle="Mi Ticket"
              contentExtraClass="w-full md:w-1/3"
              renderTrigger={(openModal) => (
                <li
                  key={ticket.tickets._id}
                  className="relative rounded-xl"
                  onClick={() => openModal()}
                >
                  <div
                    className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 
                       w-6 h-6 dark:bg-neutral-800 bg-white rounded-full z-10 pointer-events-none"
                  ></div>

                  <div
                    className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 
                       w-6 h-6 dark:bg-neutral-800 bg-white rounded-full z-10 pointer-events-none"
                  ></div>

                  <div
                    className={`relative shadow-lg rounded-xl transition-transform duration-300 ease-in-out hover:scale-110
                       flex items-center justify-center overflow-hidden hover:cursor-pointer
                    ${
                      isLucky
                        ? "bg-gradient-to-tr from-yellow-300 via-yellow-400 to-yellow-500 dark:from-yellow-600 dark:to-yellow-700"
                        : "bg-gradient-to-tr from-[rgb(226,232,240)] to-[rgb(255,247,233)] dark:bg-gradient-to-r dark:from-[rgb(51,65,85)] dark:to-[rgb(71,85,110)]"
                    }`}
                  >
                    <p className="text-xs font-bold tracking-widest text-neutral-900 dark:text-white text-center px-6 py-4 mt-1 mb-1">
                      {ticket.tickets.numberRaffle}
                    </p>
                  </div>
                </li>
              )}
              renderContent={() => (
                <div className="flex flex-col items-center">
                  <img
                    src={ticket.tickets.qrTicket}
                    alt="QR Code"
                    className="w-1/2 h-auto mt-4 rounded-lg "
                  />
                </div>
              )}
            />
          );
        })}
    </ul>
  );
};

export default RaffleTickets;
